<template>
  <Card>
    <span slot="title">挂号数据统计报表</span>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getRegistrationList)">刷新</el-button>
    <div slot="content" class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-select v-model="searchForm.deptIds" multiple placeholder="请选择医馆名称">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="月份">
            <el-date-picker v-model="searchForm.date" value-format="yyyy-MM" type="monthrange" align="right"
            unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
            :picker-options="pickerOptions" @change="val => $setDates(val, getRegistrationList)"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getRegistrationList, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getRegistrationList, { deptIds: [], dates: [], date: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button @click="$exportSummary(searchForm, '/report/export/orderRegister', '挂号数据统计')"
        icon="el-icon-download" type="primary">导出报表</el-button>
      </div>
      <!-- 挂号数据统计列表 -->
      <el-table v-loading="loading" :data="registrationList" :max-height="tableHeight" border>
        <el-table-column fixed label="医馆名称" prop="deptName" min-width="150">
          <template slot-scope="scope">杏林春堂-{{scope.row.deptName}}</template>
        </el-table-column>
        <el-table-column fixed label="医生姓名" prop="doctorName" min-width="80"/>
        <el-table-column label="患者名称" prop="patientName" min-width="80"/>
        <el-table-column label="性别" prop="sex"/>
        <el-table-column label="手机号" prop="phone" min-width="120"/>
        <el-table-column label="渠道" prop="channel"/>
        <el-table-column label="患者类型" prop="visit" min-width="90"/>
        <el-table-column label="号数" prop="registeredCode"/>
        <el-table-column label="患者来源" prop="source" min-width="100"/>
        <el-table-column label="状态" prop="status" min-width="90"/>
        <el-table-column label="挂号费(元)" prop="price" min-width="90"/>
        <el-table-column label="实收(元)" prop="realPay"/>
        <el-table-column label="收费员" prop="createBy" min-width="100"/>
        <el-table-column label="创建日期" prop="createTime" min-width="160"/>
      </el-table>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getRegistrationList)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </Card>
</template>

<script lang="js">
import { registrationStatistics } from "@/api/statement"; // 报表统计请求
export default {
  name: 'RegistrationStatistics',
  data() {
    return {
      loading: false, // 加载中
      searchForm: { deptIds: [], dates: [], date: null }, // 查询表单
      registrationList: [], // 挂号数据统计列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      deptOptions: this.$session.get('options'), // 医馆列表
      pickerOptions:{ // 排班日期可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.$shortcuts
      },
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.$forceUpdate();
    this.$setCurMonth(this.getRegistrationList);
  },
  methods: {
    // 请求所有挂号数据统计列表
    async getRegistrationList() {
      let { rows, code, total } = await registrationStatistics(this.currentPage, this.pageSize, this.searchForm);
      if (code == 200) {
        this.registrationList = rows;
        this.total = total;
      }
      this.loading = false;
    }
  },
};
</script>